import { QueryConsumer } from 'app/components/Contexts';
import { getFlash } from 'app/services/flash';
import { fold } from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/pipeable';
import * as t from 'io-ts';
import React, { Component, ReactNode, SFC } from 'react';

const Result = t.union([
  t.intersection([
    t.interface({
      success: t.boolean,
    }),
    t.partial({
      error: t.any,
    }),
  ]),
  t.nullType,
]);

export type IResult = t.TypeOf<typeof Result>;

interface IProps {
  children: (args: IResult) => ReactNode;
}

interface IDependencies {
  query: {
    resultKey?: string;
  };
}

interface IState {
  result: IResult;
}

class GetOauthResult extends Component<IProps & IDependencies, IState> {
  public constructor(props: any) {
    super(props);
    const { resultKey } = props.query;
    const result = pipe(
      Result.decode(resultKey && getFlash(resultKey)),
      fold(() => null, (r) => r),
    );
    this.state = { result };
  }

  public render() {
    const { result } = this.state;
    return this.props.children(result);
  }
}

const GetOauthResultInjectDependencies: SFC<IProps> = (props) => (
  <QueryConsumer>{(query) =>
    <GetOauthResult query={query} {...props} />
  }</QueryConsumer>
);

export default GetOauthResultInjectDependencies;
